export var UPDATE_CURRENT_SELECTED_TRANSACTIONS_TAB = "UPDATE_CURRENT_SELECTED_TRANSACTIONS_TAB";
export var CLIENTS_OF_RM_START_LOADER = "CLIENTS_OF_RM_START_LOADER";
export var CLIENTS_OF_RM_STOP_LOADER = "CLIENTS_OF_RM_STOP_LOADER";
export var GET_CLIENTS_OF_RM = "GET_CLIENTS_OF_RM";
export var CLIENTS_OF_RM_ERROR = "CLIENTS_OF_RM_ERROR";
export var CLIENTS_OF_RM_HIDE_ERROR = "CLIENTS_OF_RM_HIDE_ERROR";
